//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LensesGlassesSelection',

  data: function () {
    return {
      windowWidth: null,
      provisionalCity: null,
      storesFromZavod: null,
      loader: false,

      links: [
        {
          title: 'от 2 до 6 лет',
          mobileTitle: '2 - 6 лет',
          url: '/zapis?step_age=2-6&step_service=40',
        },
        {
          title: 'от 7 до 11 лет',
          mobileTitle: '7 - 11 лет',
          url: '/zapis?step_age=7-11&step_service=42',
        },
        {
          title: 'от 12 до 18 лет',
          mobileTitle: '12 - 18 лет',
          url: '/zapis?step_age=12-18&step_service=41',
        },
        {
          title: 'старше 18 лет',
          mobileTitle: 'от 18 лет',
          url: '/zapis?step_age=19&step_service=8',
        }
      ]
    }
  },

  computed: {
    isCityHaveStoresOnZavod: function () {
      return this.storesFromZavod?.link ? this.storesFromZavod.link : 'https://zavododv.ru/salony-optiki'
    },
    isCityHaveStoresOnLinza: function() {
      return this.storesFromZavod?.exist_locally || '';
    },
    isMobile: function() {
      if (!process.client) {
        return
      }
      return this.windowWidth < 1000;
    },
    cityFromStoreState: function () {
      return this.$store.state?.appState?.config?.city?.data?.id || this.$store.state?.appState?.config?.city?.model.id || '';
    },
  },

  mounted: async function() {
    window.addEventListener('resize', this.handleWindowSize);
    // await this.checkCityApi();
    await this.checkPartnersStoresOnZavod();
    this.handleWindowSize();
  },

  unMounted: function() {
    window.removeEventListener('resize', this.handleWindowSize);
  },

  methods: {
    checkPartnersStoresOnZavod: async function() {
      this.loader = true;
      const zavodStores = await this.$api.agent.transport.get(`/stores/check-zavod/${this.cityFromStoreState || 1}`)
        .then((res) => {
          return res.data
        }).catch((err) => {
          console.log('err', err)
          return err
        })
      if (!zavodStores) {
        this.storesFromZavod = null;
        return
      }
      this.storesFromZavod = zavodStores;
      this.loader = false;
    },
    handleWindowSize: function() {
      this.windowWidth = window.innerWidth;
    }
  }
}
